export const KNOWLEDGE_PORTAL_LINK =
  'https://desk.zoho.com/portal/berkeleypayment/kb/support/cardholders/';
export const TERMS_AND_CONDITONS_LINK =
  'https://berkeleypayment.com/terms-of-use/';
export const PRIVACY_POLICY_LINK =
  'https://berkeleypayment.com/privacy-policy/';
export const HRB_KNOWLEDGE_BASE_LINK =
  'https://hrblockadvantagecard.mycardholdersupport.com';
export const DEFAULT_KNOWLEDGE_BASE_LINK =
  'https://help.mycardholdersupport.com';
